import { render, staticRenderFns } from "./supplierLogin.vue?vue&type=template&id=14c27970&scoped=true"
import script from "./supplierLogin.vue?vue&type=script&lang=js"
export * from "./supplierLogin.vue?vue&type=script&lang=js"
import style0 from "./supplierLogin.vue?vue&type=style&index=0&id=14c27970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c27970",
  null
  
)

export default component.exports